import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { productCategories } from "@/lib/product";

let cache = null;

/** Categorienamen uit het CRM (webshop_categorie), één keer per sessie opgehaald. */
export function useCategories() {
  const { producten, isAuthenticated } = useAuth();
  const [categorieen, setCategorieen] = useState(cache || []);

  useEffect(() => {
    if (!isAuthenticated) {
      cache = null;
      setCategorieen([]);
      return undefined;
    }
    if (cache) return undefined;
    let actief = true;
    producten()
      .then((data) => {
        cache = productCategories(data);
        if (actief) setCategorieen(cache);
      })
      .catch(() => { /* geen categorieën = geen menu */ });
    return () => { actief = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return categorieen;
}
